
import axios from "axios";
import { useEffect, useRef, useState } from "react";
import {
    FiBriefcase,
    FiCalendar,
    FiCheckCircle,
    FiMail,
    FiAlertTriangle,
    FiEye,
    FiFileText,
    FiMapPin,
    FiPhone,
    FiStar,
    FiX,
    FiClock,
    FiTrash2,
    FiDownload,
    FiAward,
    FiUsers,
    FiUser,
    FiTrendingUp,
    FiClipboard
} from "react-icons/fi";
import { useNavigate } from "react-router-dom";
import "./EmployeeDashboard.css";

const API_BASE_URL = 'https://ingrainhirebackend.ingrainsystems.com/api';

const DetailItem = ({ icon, label, value }) => (
    <div className="emp-dash__detail-row">
        <span className="emp-dash__detail-label">{label}</span>
        <span className="emp-dash__detail-value">{value || "N/A"}</span>
    </div>
);

const Score = () => {
    const [candidates, setCandidates] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState("");
    const [searchQuery, setSearchQuery] = useState("");
    const [scoreFilter, setScoreFilter] = useState(0);
    const [roleFilter, setRoleFilter] = useState("");
    const [dateFilter, setDateFilter] = useState("");
    const [roles, setRoles] = useState([]);
    const [roleSearchQuery, setRoleSearchQuery] = useState("");
    const [isRoleDropdownOpen, setIsRoleDropdownOpen] = useState(false);
    const roleDropdownRef = useRef(null);
    const [selectedCandidate, setSelectedCandidate] = useState(null);
    const [isInviteModalOpen, setIsInviteModalOpen] = useState(false);
    const [inviteForm, setInviteForm] = useState({
        subject: "Interview Invitation - Timely Health",
        time: "",
        interviewMode: "Online",
    });

    const [locations, setLocations] = useState([]);
    const [isDocsModalOpen, setIsDocsModalOpen] = useState(false);
    const [isAssessmentModalOpen, setIsAssessmentModalOpen] = useState(false);
    const [selectedAssessmentData, setSelectedAssessmentData] = useState(null);
    const [docsForm, setDocsForm] = useState({
        agreementsContent: "Please read, sign, and re-upload this agreement for next steps.",
    });
    const [personalDocs, setPersonalDocs] = useState(null);
    const [personalDocsLoading, setPersonalDocsLoading] = useState(false);

    const [quizzes, setQuizzes] = useState([]);

    const formatDocUrl = (url) => {
        if (!url) return "";
        const cleanUrl = url.startsWith("/") ? url : `/${url}`;
        return `${API_BASE_URL.replace("/api", "")}${cleanUrl.replace(/\\/g, "/")}`;
    };

    // Pagination states
    const [pagination, setPagination] = useState({
        currentPage: 1,
        totalPages: 1,
        totalCount: 0,
        limit: 10,
    });

    const [isPackageModalOpen, setIsPackageModalOpen] = useState(false);
    const [packageSalary, setPackageSalary] = useState("");
    const [packageJoiningDate, setPackageJoiningDate] = useState("");
    const [packageNoticePeriod, setPackageNoticePeriod] = useState("");
    const [packageProbationPeriod, setPackageProbationPeriod] = useState("");
    const [packageDailyAllowance, setPackageDailyAllowance] = useState("");
    const [packagePerformanceAllowance, setPackagePerformanceAllowance] = useState("");
    const [isDetailsModalOpen, setIsDetailsModalOpen] = useState(false);
    const [isHistoryModalOpen, setIsHistoryModalOpen] = useState(false);
    const [historyLoading, setHistoryLoading] = useState(false);

    const navigate = useNavigate();

    // Get clientId from localStorage
    const getClientId = () => {
        return localStorage.getItem('clientId') || localStorage.getItem('clientCustomId') || '';
    };

    useEffect(() => {
        fetchCandidates();
        fetchQuizzes();
        fetchLocations();
        fetchRoles();

        const handleClickOutside = (event) => {
            if (roleDropdownRef.current && !roleDropdownRef.current.contains(event.target)) {
                setIsRoleDropdownOpen(false);
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, []);

    const fetchRoles = async () => {
        try {
            const clientId = getClientId();
            let url;
            if (clientId) {
                url = `${API_BASE_URL}/jobs/all/${clientId}`;
            } else {
                url = `${API_BASE_URL}/jobs/all`;
            }
            const res = await axios.get(url);
            if (res.data.success) {
                const rolesData = res.data.jobPosts || [];
                const formattedRoles = rolesData.map((job, index) => ({
                    _id: job._id || index,
                    name: job.role
                }));
                const uniqueRoles = Array.from(new Set(formattedRoles.map(r => r.name)))
                    .filter(name => name && !name.toLowerCase().includes("resign"))
                    .map(name => formattedRoles.find(r => r.name === name));
                setRoles(uniqueRoles);
            }
        } catch (err) {
            console.error("Failed to fetch roles:", err);
        }
    };

    const fetchLocations = async () => {
        try {
            const clientId = getClientId();
            let url;
            if (clientId) {
                url = `${API_BASE_URL}/location/alllocation?clientId=${clientId}`;
            } else {
                url = `${API_BASE_URL}/location/alllocation`;
            }
            const res = await axios.get(url);
            if (res.data?.locations) setLocations(res.data.locations);
        } catch (err) {
            console.error("Failed to fetch locations:", err);
        }
    };

    const fetchQuizzes = async () => {
        try {
            const clientId = getClientId();
            let url;
            if (clientId) {
                url = `${API_BASE_URL}/admin/getallquizes/${clientId}`;
            } else {
                url = `${API_BASE_URL}/admin/getallquizes`;
            }
            const res = await axios.get(url);
            if (res.data?.quizzes) setQuizzes(res.data.quizzes);
        } catch (err) {
            console.error("Failed to fetch quizzes:", err);
        }
    };

    const fetchCandidates = async () => {
        try {
            setLoading(true);
            const clientId = getClientId();
            let url;
            if (clientId) {
                url = `${API_BASE_URL}/applications/all/${clientId}`;
            } else {
                url = `${API_BASE_URL}/applications/all`;
            }
            const res = await axios.get(url);
            if (res.data.success) {
                setCandidates(res.data.applications || []);
            }
        } catch (err) {
            setError("Failed to fetch candidates score data");
            console.error(err);
        } finally {
            setLoading(false);
        }
    };

    const handleUpdateScore = async (id, field, value) => {
        const numericValue = (field === "status") ? value : Number(value);
        const clientId = getClientId();

        try {
            const res = await axios.post(`${API_BASE_URL}/applications/update-score`, {
                applicationId: id,
                clientId: clientId,
                [field]: numericValue,
            });
            if (res.data.success) {
                setCandidates((prev) =>
                    prev.map((c) => (c._id === id ? { ...c, [field]: numericValue } : c))
                );
            }
        } catch (err) {
            console.error("Update score error:", err);
        }
    };

    const handleOpenInviteModal = (candidate) => {
        setSelectedCandidate(candidate);
        setIsInviteModalOpen(true);
    };

    const handleSendInvite = async () => {
        if (!inviteForm.time || !inviteForm.subject) {
            alert("Please fill in all fields");
            return;
        }

        const clientId = getClientId();

        try {
            const res = await axios.post(`${API_BASE_URL}/applications/send-invitation`, {
                applicationId: selectedCandidate._id,
                clientId: clientId,
                interviewSubject: inviteForm.subject,
                interviewTime: inviteForm.time,
                interviewMode: inviteForm.interviewMode,
            });

            if (res.data.success) {
                alert("Interview invitation sent successfully!");
                setIsInviteModalOpen(false);
                fetchCandidates();
            }
        } catch (err) {
            console.error("Send invite error:", err);
            alert("Failed to send invitation");
        }
    };

    const handleOpenOfferModal = (candidate) => {
        navigate(`/send-offer?id=${candidate._id}&email=${candidate.email}`);
    };

    const handleOpenPackageModal = (candidate) => {
        setSelectedCandidate(candidate);
        setPackageSalary(candidate.finalSalary || candidate.expectedCTC || "");
        setPackageJoiningDate(candidate.dateOfJoining || "");
        setPackageNoticePeriod(candidate.noticePeriod || "");
        setPackageProbationPeriod(candidate.probationPeriod || "");
        setPackageDailyAllowance(candidate.dailyAllowance || "");
        setPackagePerformanceAllowance(candidate.performanceAllowance || "");
        setIsPackageModalOpen(true);
    };

    const handleOpenDetailsModal = (candidate) => {
        setSelectedCandidate(candidate);
        setIsDetailsModalOpen(true);
    };

    const handleSavePackage = async () => {
        const clientId = getClientId();
        try {
            const res = await axios.post(`${API_BASE_URL}/applications/update-score`, {
                applicationId: selectedCandidate._id,
                clientId: clientId,
                finalSalary: packageSalary,
                dateOfJoining: packageJoiningDate,
                noticePeriod: packageNoticePeriod,
                probationPeriod: packageProbationPeriod,
                dailyAllowance: packageDailyAllowance,
                performanceAllowance: packagePerformanceAllowance,
            });
            if (res.data.success) {
                alert("Package updated successfully!");
                setIsPackageModalOpen(false);
                fetchCandidates();
            }
        } catch (err) {
            console.error("Save package error:", err);
            alert("Failed to save package");
        }
    };

    const handleOpenDocsModal = async (candidate) => {
        setSelectedCandidate(candidate);
        setDocsForm({ agreementsContent: candidate.adminAgreements || "Please read, sign, and re-upload this agreement for next steps." });
        setIsDocsModalOpen(true);

        // Fetch personal documents
        if (candidate.candidateId?._id || candidate.candidateId) {
            const candidateId = candidate.candidateId?._id || candidate.candidateId;
            const clientId = getClientId();
            try {
                setPersonalDocsLoading(true);
                const res = await axios.get(`${API_BASE_URL}/candidate/admin/${candidateId}?clientId=${clientId}`);
                if (res.data.success) {
                    setPersonalDocs(res.data.data);
                }
            } catch (err) {
                console.error("Failed to fetch candidate documents:", err);
                setPersonalDocs(null);
            } finally {
                setPersonalDocsLoading(false);
            }
        }
    };

    const handleOpenHistoryModal = (candidate) => {
        setSelectedCandidate(candidate);
        setIsHistoryModalOpen(true);
    };

    const handleDeleteHistoryItem = async (historyId) => {
        if (!window.confirm("Are you sure you want to delete this history item?")) return;

        const clientId = getClientId();

        try {
            setHistoryLoading(true);
            const res = await axios.post(`${API_BASE_URL}/applications/delete-history-item`, {
                applicationId: selectedCandidate._id,
                clientId: clientId,
                historyId: historyId
            });

            if (res.data.success) {
                alert("History item deleted successfully!");
                setSelectedCandidate(res.data.application);
                setCandidates(prev => prev.map(c => c._id === res.data.application._id ? res.data.application : c));
            }
        } catch (err) {
            console.error("Failed to delete history item:", err);
            alert("Failed to delete history item");
        } finally {
            setHistoryLoading(false);
        }
    };

    const handleOpenAssessmentDetails = (candidate) => {
        if (!candidate.assessmentResults || candidate.assessmentResults.length === 0) {
            alert("No assessment data available for this candidate.");
            return;
        }

        const allAssessments = candidate.assessmentResults.map((result) => {
            let matchedQuiz = null;
            if (result.quizId && typeof result.quizId === 'object' && result.quizId.questions) {
                matchedQuiz = result.quizId;
            } else {
                const quizId = typeof result.quizId === 'object' ? result.quizId?._id : result.quizId;
                matchedQuiz = quizzes.find(q => String(q._id) === String(quizId));

                if (!matchedQuiz && candidate.comment) {
                    const titleMatch = candidate.comment.match(/"([^"]+)"/);
                    if (titleMatch?.[1]) {
                        matchedQuiz = quizzes.find(q => q.title === titleMatch[1]);
                    }
                }
            }

            let enrichedAnswers = [];

            if (matchedQuiz && matchedQuiz.questions && matchedQuiz.questions.length > 0) {
                enrichedAnswers = matchedQuiz.questions.map((q, idx) => {
                    const storedByText = result.answers?.find(a => a.questionText === q.questionText);
                    const storedByIndex = result.answers?.[idx];
                    const storedAns = storedByText || storedByIndex;

                    const selected = storedAns?.selectedOption || "Not Answered";
                    const correct = q.correctAnswer || "";

                    return {
                        questionText: q.questionText,
                        options: q.options || [],
                        correctAnswer: correct,
                        selectedOption: selected,
                        isCorrect: String(selected).trim() === String(correct).trim(),
                        marks: q.marks || 1,
                    };
                });
            } else if (result.answers && result.answers.length > 0) {
                enrichedAnswers = result.answers.map(ans => ({
                    questionText: ans.questionText || "Question",
                    options: ans.options?.length > 0
                        ? ans.options
                        : [ans.selectedOption, ans.correctAnswer].filter(Boolean),
                    correctAnswer: ans.correctAnswer || "",
                    selectedOption: ans.selectedOption || "Not Answered",
                    isCorrect: ans.isCorrect !== undefined
                        ? ans.isCorrect
                        : String(ans.selectedOption).trim() === String(ans.correctAnswer).trim(),
                    marks: ans.marks || 1
                }));
            }

            return {
                ...result,
                answers: enrichedAnswers,
                quizTitle: matchedQuiz?.title || "Assessment"
            };
        });

        setSelectedAssessmentData(allAssessments);
        setSelectedCandidate(candidate);
        setIsAssessmentModalOpen(true);
    };

    const [docsFile, setDocsFile] = useState(null);

    const handleSendAgreements = async () => {
        const formData = new FormData();
        const clientId = getClientId();
        formData.append("applicationId", selectedCandidate._id);
        formData.append("clientId", clientId);
        formData.append("agreementsContent", docsForm.agreementsContent);
        if (docsFile) {
            formData.append("adminAttachment", docsFile);
        }

        try {
            const res = await axios.post(`${API_BASE_URL}/applications/send-agreements`, formData, {
                headers: { "Content-Type": "multipart/form-data" }
            });
            if (res.data.success) {
                alert("Agreements sent successfully!");
                setDocsFile(null);
                fetchCandidates();
            }
        } catch (err) {
            console.error(err);
            alert("Failed to send agreements");
        }
    };

    const handleReviewDocs = async (status) => {
        const clientId = getClientId();
        try {
            const res = await axios.post(`${API_BASE_URL}/applications/review-documents`, {
                applicationId: selectedCandidate._id,
                clientId: clientId,
                status
            });
            if (res.data.success) {
                alert(`Documents ${status}`);
                setIsDocsModalOpen(false);
                fetchCandidates();
            }
        } catch (err) {
            console.error(err);
            alert("Failed to update status");
        }
    };

    const filteredCandidates = candidates.filter(c => {
        if (c.jobId?.role?.toLowerCase().includes("resign") || c.status === "Resigned" || c.documentType === "Resignation" || c.jobId?.jobType === "short") return false;

        const query = searchQuery.toLowerCase();
        const matchesSearch = `${c.firstName} ${c.lastName}`.toLowerCase().includes(query) ||
            (c.jobId?.role || "").toLowerCase().includes(query);

        const matchesScore = (c.technicalScore || 0) >= scoreFilter;
        const matchesRole = roleFilter ? (c.jobId?.role === roleFilter) : true;

        const matchesDate = dateFilter
            ? new Date(c.appliedAt).toISOString().slice(0, 10) === dateFilter
            : true;

        return matchesSearch && matchesScore && matchesRole && matchesDate;
    });

    // Pagination Handlers
    const handleItemsPerPageChange = (limit) => {
        setPagination({
            currentPage: 1,
            limit: limit,
            totalCount: filteredCandidates.length,
            totalPages: Math.ceil(filteredCandidates.length / limit)
        });
    };

    const handlePrevPage = () => {
        if (pagination.currentPage > 1) {
            setPagination(prev => ({
                ...prev,
                currentPage: prev.currentPage - 1
            }));
        }
    };

    const handleNextPage = () => {
        if (pagination.currentPage < pagination.totalPages) {
            setPagination(prev => ({
                ...prev,
                currentPage: prev.currentPage + 1
            }));
        }
    };

    const handlePageClick = (page) => {
        setPagination(prev => ({
            ...prev,
            currentPage: page
        }));
    };

    const getPageNumbers = () => {
        const pageNumbers = [];
        for (let i = 1; i <= pagination.totalPages; i++) {
            if (
                i === 1 ||
                i === pagination.totalPages ||
                (i >= pagination.currentPage - 2 && i <= pagination.currentPage + 2)
            ) {
                pageNumbers.push(i);
            } else if (i === pagination.currentPage - 3 || i === pagination.currentPage + 3) {
                pageNumbers.push("...");
            }
        }
        return pageNumbers;
    };

    // Update pagination when filtered results change
    useEffect(() => {
        setPagination(prev => ({
            ...prev,
            totalCount: filteredCandidates.length,
            totalPages: Math.ceil(filteredCandidates.length / prev.limit),
            currentPage: 1
        }));
    }, [filteredCandidates.length, searchQuery, scoreFilter, roleFilter, dateFilter]);

    // Calculate pagination
    const indexOfLastItem = pagination.currentPage * pagination.limit;
    const indexOfFirstItem = indexOfLastItem - pagination.limit;
    const currentItems = filteredCandidates.slice(indexOfFirstItem, indexOfLastItem);

    const resetFilters = () => {
        setSearchQuery("");
        setScoreFilter(0);
        setRoleFilter("");
        setRoleSearchQuery("");
        setDateFilter("");
    };

    if (loading) return (
        <div style={{backgroundColor:'white'}} className="emp-dash">
            <main className="p-4 sm:p-6 lg:p-8">
                <div className="py-10 text-center">
                    <div className="flex flex-col items-center justify-center gap-3">
                        <div className="emp-dash__spinner"></div>
                        <span className="text-sm font-medium text-gray-500">Syncing score data...</span>
                    </div>
                </div>
            </main>
        </div>
    );

    return (
        <div style={{backgroundColor:'white'}} className="emp-dash">
            <main className="p-4 sm:p-6 lg:p-8">
                {/* Dashboard Header */}
                <div className="emp-dash__header">
                    <div>
                        <h1 className="emp-dash__greeting">
                            Score <span>Board</span>
                        </h1>
                        <p className="emp-dash__subtitle">
                            Evaluate and manage candidate scores
                        </p>
                    </div>
                    <div className="emp-dash__date-pill">
                        <FiClipboard />
                        <span>
                            {new Date().toLocaleDateString("en-US", {
                                weekday: "short",
                                year: "numeric",
                                month: "short",
                                day: "numeric",
                            })}
                        </span>
                    </div>
                </div>

                {/* Filters Section */}
                <div className="emp-dash__card mb-6">
                    <div className="emp-dash__card-body">
                        <div className="flex flex-wrap items-center gap-2">

                            {/* Search Bar */}
                            <div className="relative flex-1 min-w-[180px]">
                                <FiUser className="absolute left-2 top-1/2 transform -translate-y-1/2 text-gray-400 text-sm" />
                                <input
                                    type="text"
                                    placeholder="Search name or role..."
                                    value={searchQuery}
                                    onChange={(e) => setSearchQuery(e.target.value)}
                                    className="w-full pl-8 pr-3 py-1.5 text-xs border border-gray-300 rounded-lg focus:ring-1 focus:ring-blue-500 focus:border-transparent"
                                />
                            </div>

                            {/* Role Filter Button */}
                            <div className="relative" ref={roleDropdownRef}>
                                <button
                                    onClick={() => setIsRoleDropdownOpen(!isRoleDropdownOpen)}
                                    className={`h-8 px-3 text-xs font-medium rounded-md transition flex items-center gap-1 ${roleFilter
                                        ? 'bg-blue-600 text-white hover:bg-blue-700'
                                        : 'bg-gray-100 text-gray-700 hover:bg-gray-200 border border-gray-300'
                                        }`}
                                >
                                    <FiBriefcase className="text-xs" /> Role {roleFilter && `: ${roleFilter}`}
                                </button>

                                {/* Role Filter Dropdown */}
                                {isRoleDropdownOpen && (
                                    <div className="absolute z-50 mt-1 w-48 bg-white border border-gray-200 rounded-md shadow-lg max-h-60 overflow-y-auto">
                                        <div className="p-2 border-b border-gray-100 bg-gray-50">
                                            <div className="relative">
                                                <FiUser className="absolute left-2 top-1/2 transform -translate-y-1/2 text-gray-400 text-xs" />
                                                <input
                                                    type="text"
                                                    className="w-full py-1 pl-7 pr-2 text-xs bg-white border border-gray-200 rounded-md focus:outline-none focus:ring-1 focus:ring-blue-500"
                                                    placeholder="Search roles..."
                                                    value={roleSearchQuery}
                                                    onChange={(e) => setRoleSearchQuery(e.target.value)}
                                                    onClick={(e) => e.stopPropagation()}
                                                    autoFocus
                                                />
                                            </div>
                                        </div>
                                        <div
                                            onClick={() => {
                                                setRoleFilter('');
                                                setIsRoleDropdownOpen(false);
                                                setRoleSearchQuery('');
                                            }}
                                            className={`px-3 py-2 text-xs hover:bg-blue-50 cursor-pointer border-b border-gray-100 font-medium ${!roleFilter ? 'bg-blue-50 text-blue-700' : 'text-gray-700'
                                                }`}
                                        >
                                            All Roles
                                        </div>
                                        {roles
                                            .filter(r => r.name.toLowerCase().includes(roleSearchQuery.toLowerCase()))
                                            .map((r) => (
                                                <div
                                                    key={r._id}
                                                    onClick={() => {
                                                        setRoleFilter(r.name);
                                                        setIsRoleDropdownOpen(false);
                                                        setRoleSearchQuery('');
                                                    }}
                                                    className={`px-3 py-2 text-xs hover:bg-blue-50 cursor-pointer ${roleFilter === r.name ? 'bg-blue-50 text-blue-700 font-medium' : 'text-gray-700'
                                                        }`}
                                                >
                                                    {r.name}
                                                </div>
                                            ))}
                                        {roles.filter(r => r.name.toLowerCase().includes(roleSearchQuery.toLowerCase())).length === 0 && (
                                            <div className="px-3 py-2 text-xs text-gray-400 text-center">
                                                No roles found
                                            </div>
                                        )}
                                    </div>
                                )}
                            </div>

                            {/* Score Filter */}
                            <div className="relative w-[130px]">
                                <select
                                    className="w-full pl-2 pr-6 py-1.5 text-xs border border-gray-300 rounded-lg focus:ring-1 focus:ring-blue-500 focus:border-transparent appearance-none"
                                    value={scoreFilter}
                                    onChange={(e) => setScoreFilter(Number(e.target.value))}
                                >
                                    <option value="0">All Scores</option>
                                    <option value="60">60% & Above</option>
                                    <option value="70">70% & Above</option>
                                    <option value="80">80% & Above</option>
                                    <option value="90">90% & Above</option>
                                </select>
                                <div className="absolute inset-y-0 right-0 flex items-center pr-1 pointer-events-none">
                                    <FiStar className="text-[8px] text-gray-400" />
                                </div>
                            </div>

                            {/* Date Filter */}
                            <div className="relative w-[130px]">
                                <span className="absolute left-2 top-1/2 -translate-y-1/2 text-[10px] text-gray-500 pointer-events-none">
                                    Date:
                                </span>
                                <input
                                    type="date"
                                    value={dateFilter}
                                    onChange={(e) => setDateFilter(e.target.value)}
                                    onClick={(e) => e.target.showPicker && e.target.showPicker()}
                                    className="w-full pl-12 pr-2 py-1.5 text-xs border border-gray-300 rounded-lg focus:ring-1 focus:ring-blue-500 focus:border-transparent"
                                />
                            </div>

                            {/* Reset Filters Button */}
                            {(searchQuery || scoreFilter > 0 || roleFilter || dateFilter) && (
                                <button
                                    onClick={resetFilters}
                                    className="h-8 px-3 text-xs font-medium text-gray-600 bg-gray-100 border border-gray-300 rounded-md hover:bg-gray-200 transition"
                                >
                                    Clear
                                </button>
                            )}
                        </div>
                    </div>
                </div>

                {error && <div className="mb-4 p-4 bg-red-50 border border-red-200 rounded-xl flex items-center gap-3">
                    <FiX className="text-red-500 text-lg" />
                    <span className="text-sm font-medium text-red-700">{error}</span>
                </div>}

            <div className="emp-dash__card mb-6">
                {filteredCandidates.length > 0 ? (
                    <div className="emp-dash__table-wrapper">
                        <table className="emp-dash__table">
                            <thead className="emp-dash__table-head">
                                <tr>
                                    <th className="emp-dash__table-th">Candidate</th>
                                    <th className="emp-dash__table-th">Role</th>
                                    <th className="emp-dash__table-th">Appearance (10)</th>
                                    <th className="emp-dash__table-th">Knowledge (10)</th>
                                    <th className="emp-dash__table-th">Avg Score (100)</th>
                                    <th className="emp-dash__table-th">Rating (10)</th>
                                    <th className="emp-dash__table-th">TAT (Days)</th>
                                    <th className="emp-dash__table-th">Status</th>
                                    <th className="emp-dash__table-th">Actions</th>
                                </tr>
                            </thead>
                            <tbody className="emp-dash__table-body">
                                {currentItems.map((c) => (
                                    <tr key={c._id} className="emp-dash__table-row">
                                        <td className="emp-dash__table-td">
                                            <div className="flex flex-col">
                                                <span className="text-gray-900 whitespace-nowrap font-bold text-sm">{c.firstName} {c.lastName}</span>
                                            </div>
                                        </td>
                                        <td className="emp-dash__table-td">
                                            <span className="bg-gray-100 text-gray-600 text-[10px] px-2 py-0.5 rounded uppercase font-bold">
                                                {c.jobId?.role || "N/A"}
                                            </span>
                                        </td>
                                        <td className="emp-dash__table-td">
                                            <input
                                                type="number"
                                                min="0"
                                                max="10"
                                                className="w-16 p-1 border rounded text-xs text-center focus:outline-none focus:ring-2 focus:ring-blue-500"
                                                value={c.appearanceScore || 0}
                                                onChange={(e) => handleUpdateScore(c._id, "appearanceScore", e.target.value)}
                                            />
                                        </td>
                                        <td className="emp-dash__table-td">
                                            <input
                                                type="number"
                                                min="0"
                                                max="10"
                                                className="w-16 p-1 border rounded text-xs text-center focus:outline-none focus:ring-2 focus:ring-blue-500"
                                                value={c.workKnowledge || 0}
                                                onChange={(e) => handleUpdateScore(c._id, "workKnowledge", e.target.value)}
                                            />
                                        </td>
                                        <td className="emp-dash__table-td">
                                            <div className="flex items-center justify-center gap-2">
                                                <div className="flex items-center gap-1">
                                                    <span className="text-[10px] text-gray-500 font-bold">AVG</span>
                                                    {c.assessmentResults && c.assessmentResults.length > 0 ? (
                                                        <span className="w-16 p-1 border rounded text-xs text-center font-bold bg-gray-100 text-gray-800">
                                                            {Math.round(c.assessmentResults.reduce((sum, res) => sum + (res.score || 0), 0) / c.assessmentResults.length)}
                                                        </span>
                                                    ) : (
                                                        <input
                                                            type="number"
                                                            min="0"
                                                            max="100"
                                                            data-gramm="false"
                                                            spellcheck="false"
                                                            className="w-16 p-1 border rounded text-xs text-center font-bold focus:outline-none focus:ring-2 focus:ring-blue-500 bg-gray-50"
                                                            value={c.technicalScore || 0}
                                                            onChange={(e) => handleUpdateScore(c._id, "technicalScore", e.target.value)}
                                                        />
                                                    )}
                                                </div>
                                                {c.assessmentResults && c.assessmentResults.length > 0 && (
                                                    <button
                                                        onClick={() => handleOpenAssessmentDetails(c)}
                                                        className="p-2 bg-indigo-50 text-indigo-600 hover:bg-indigo-600 hover:text-white rounded-xl transition-all duration-300 shadow-sm hover:shadow-md border border-indigo-100 group flex items-center justify-center transform hover:-translate-y-0.5"
                                                        title="View Answer Sheets"
                                                    >
                                                        <FiEye size={14} className="group-hover:scale-110 transition-transform" />
                                                    </button>
                                                )}
                                            </div>
                                        </td>

                                        <td className="emp-dash__table-td">
                                            <select
                                                className="p-1 border rounded text-xs font-bold focus:outline-none focus:ring-2 focus:ring-blue-500"
                                                value={c.overallRating || 0}
                                                onChange={(e) => handleUpdateScore(c._id, "overallRating", e.target.value)}
                                            >
                                                {[0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map(v => <option key={v} value={v}>{v}</option>)}
                                            </select>
                                        </td>
                                        <td className="emp-dash__table-td">
                                            {c.appliedAt && c.offerSentAt ? (
                                                <span className="bg-indigo-50 text-indigo-700 px-2 py-1 rounded-lg text-xs font-bold border border-indigo-100 shadow-sm">
                                                    {Math.ceil(Math.abs(new Date(c.offerSentAt) - new Date(c.appliedAt)) / (1000 * 60 * 60 * 24))} Days
                                                </span>
                                            ) : (
                                                <span className="text-gray-400 text-[10px] font-black italic uppercase tracking-widest">
                                                    {c.status === "Selected" && !c.offerSentAt ? "Pending Offer" : "---"}
                                                </span>
                                            )}
                                        </td>
                                        <td className="emp-dash__table-td">
                                            <select
                                                className={`p-1 border rounded text-[10px] font-bold ${c.status === "Selected" ? "text-green-600 bg-green-50" :
                                                    c.status === "Interview" ? "text-blue-600 bg-blue-50" : "text-gray-600"
                                                    }`
                                                }

                                                value={c.status || "Pending"}
                                                onChange={(e) => handleUpdateScore(c._id, "status", e.target.value)}
                                            >
                                                <option value="Pending">PENDING</option>
                                                <option value="Shortlisted">SHORTLISTED</option>
                                                <option value="Interview">INTERVIEW</option>
                                                <option value="Selected">SELECTED</option>
                                                <option value="Rejected">REJECTED</option>
                                            </select>
                                            {(c.interviewStatus === 'Invited' || c.interviewStatus === 'Rescheduled') && c.candidateInterviewStatus && (
                                                <div className="mt-1">
                                                    <span className={`text-[8px] font-black uppercase tracking-tighter ${c.candidateInterviewStatus === 'Confirmed' ? 'text-indigo-600 bg-indigo-50 px-1 rounded' : c.candidateInterviewStatus === 'Declined' ? 'text-rose-600 bg-rose-50 px-1 rounded' : 'text-amber-600 bg-amber-50 px-1 rounded'}`}>
                                                        {c.candidateInterviewStatus === 'Pending' ? 'Awaiting Conf' : `Interview ${c.candidateInterviewStatus}`}
                                                    </span>
                                                    {c.candidateInterviewNote && (
                                                        <div className="text-[8px] text-gray-400 italic truncate max-w-[80px] mx-auto mt-0.5" title={c.candidateInterviewNote}>
                                                            "{c.candidateInterviewNote}"
                                                        </div>
                                                    )}
                                                </div>
                                            )}
                                        </td>
                                        <td className="emp-dash__table-td">
                                            <div className="flex justify-center gap-2">
                                                {c.status === "Interview" && (
                                                    <button
                                                        onClick={() => handleOpenInviteModal(c)}
                                                        className="px-3 py-1.5 bg-gradient-to-r from-blue-500 to-indigo-600 text-white rounded-xl hover:from-blue-600 hover:to-indigo-700 transition-all duration-300 flex items-center justify-center gap-1.5 text-[10px] font-black tracking-widest shadow-md hover:shadow-lg hover:-translate-y-0.5"
                                                    >
                                                        INVITE
                                                    </button>
                                                )}

                                                {c.status === "Selected" && (
                                                    <div className="flex gap-2">
                                                        <button
                                                            onClick={() => handleOpenDetailsModal(c)}
                                                            className="px-3 py-1.5 bg-gradient-to-r from-gray-500 to-gray-700 text-white rounded-xl hover:from-gray-600 hover:to-gray-800 transition-all duration-300 flex items-center justify-center gap-1.5 text-[10px] font-black tracking-widest shadow-md hover:shadow-lg hover:-translate-y-0.5"
                                                        >
                                                            <FiEye size={12} /> VIEW
                                                        </button>
                                                        {c.resume && (
                                                            <button
                                                                onClick={() => {
                                                                    const link = document.createElement('a');
                                                                    link.href = formatDocUrl(c.resume);
                                                                    link.download = `${c.firstName}_Resume.pdf`;
                                                                    document.body.appendChild(link);
                                                                    link.click();
                                                                    document.body.removeChild(link);
                                                                }}
                                                                className="px-3 py-1.5 bg-gradient-to-r from-blue-400 to-indigo-500 text-white rounded-xl hover:from-blue-500 hover:to-indigo-600 transition-all duration-300 flex items-center justify-center gap-1.5 text-[10px] font-black tracking-widest shadow-md hover:shadow-lg hover:-translate-y-0.5"
                                                                title="Download Resume"
                                                            >
                                                                <FiDownload size={12} /> RESUME
                                                            </button>
                                                        )}
                                                        <button
                                                            onClick={() => handleOpenOfferModal(c)}
                                                            className="px-3 py-1.5 bg-gradient-to-r from-purple-500 to-fuchsia-600 text-white rounded-xl hover:from-purple-600 hover:to-fuchsia-700 transition-all duration-300 flex items-center justify-center gap-1.5 text-[10px] font-black tracking-widest shadow-md hover:shadow-lg hover:-translate-y-0.5"
                                                        >
                                                            OFFER
                                                        </button>

                                                        <button
                                                            onClick={() => handleOpenDocsModal(c)}
                                                            className={`px-3 py-1.5 text-white rounded-xl transition-all duration-300 flex items-center justify-center gap-1.5 text-[10px] font-black tracking-widest shadow-md hover:shadow-lg hover:-translate-y-0.5 ${c.docReviewStatus === "Accepted"
                                                                ? "bg-gradient-to-r from-emerald-500 to-teal-500 hover:from-emerald-600 hover:to-teal-600"
                                                                : c.docReviewStatus === "Pending"
                                                                    ? "bg-gradient-to-r from-amber-500 to-orange-500 hover:from-amber-600 hover:to-orange-600"
                                                                    : "bg-gradient-to-r from-slate-700 to-slate-800 hover:from-slate-800 hover:to-slate-900"
                                                                }`
                                                            }

                                                        >
                                                            DOCS
                                                        </button>

                                                        <button
                                                            onClick={() => handleOpenPackageModal(c)}
                                                            className="px-3 py-1.5 bg-gradient-to-r from-indigo-500 to-blue-600 text-white rounded-xl hover:from-indigo-600 hover:to-blue-700 transition-all duration-300 flex items-center justify-center gap-1.5 text-[10px] font-black tracking-widest shadow-md hover:shadow-lg hover:-translate-y-0.5"
                                                        >
                                                            PACKAGE
                                                        </button>

                                                        <button
                                                            onClick={() => handleOpenHistoryModal(c)}
                                                            className="px-3 py-1.5 bg-gradient-to-r from-slate-500 to-slate-700 text-white rounded-xl hover:from-slate-600 hover:to-slate-800 transition-all duration-300 flex items-center justify-center gap-1.5 text-[10px] font-black tracking-widest shadow-md hover:shadow-lg hover:-translate-y-0.5"
                                                            title="Document History"
                                                        >
                                                            <FiClock size={12} /> HISTORY
                                                        </button>
                                                    </div>
                                                )}
                                            </div>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>

                        {/* Pagination */}
                        {filteredCandidates.length > 0 && (
                            <div className="flex flex-col items-center justify-between px-4 py-3 border-t border-gray-200 bg-gray-50 sm:flex-row">
                                <div className="flex flex-wrap items-center gap-2 text-sm text-gray-700">
                                    <span>Showing</span>
                                    <span className="font-medium">
                                        {indexOfFirstItem + 1}
                                    </span>
                                    <span>to</span>
                                    <span className="font-medium">
                                        {Math.min(indexOfLastItem, filteredCandidates.length)}
                                    </span>
                                    <span>of</span>
                                    <span className="font-medium">
                                        {filteredCandidates.length}
                                    </span>
                                    <span>results</span>

                                    <select
                                        value={pagination.limit}
                                        onChange={(e) => {
                                            const newLimit = Number(e.target.value);
                                            handleItemsPerPageChange(newLimit);
                                        }}
                                        className="p-1 ml-2 text-sm border rounded-lg"
                                    >
                                        <option value={5}>5</option>
                                        <option value={10}>10</option>
                                        <option value={20}>20</option>
                                        <option value={50}>50</option>
                                    </select>
                                </div>

                                <div className="flex items-center gap-2 mt-2 sm:mt-0">
                                    <button
                                        onClick={handlePrevPage}
                                        disabled={pagination.currentPage === 1}
                                        className={`px-4 py-2 border rounded-lg text-sm font-medium transition-colors ${pagination.currentPage === 1
                                            ? "bg-gray-100 text-gray-400 cursor-not-allowed"
                                            : "bg-white text-gray-700 border-gray-300 hover:bg-gray-50"
                                            }`}
                                    >
                                        Previous
                                    </button>

                                    <div className="flex items-center gap-1">
                                        {getPageNumbers().map((page, index) => (
                                            <button
                                                key={index}
                                                onClick={() => typeof page === 'number' ? handlePageClick(page) : null}
                                                disabled={page === "..."}
                                                className={`px-3 py-2 rounded-lg text-sm font-medium transition-colors ${page === "..."
                                                    ? "text-gray-500 cursor-default"
                                                    : pagination.currentPage === page
                                                        ? "bg-blue-600 text-white"
                                                        : "bg-white text-gray-700 border border-gray-300 hover:bg-gray-50"
                                                    }`}
                                            >
                                                {page}
                                            </button>
                                        ))}
                                    </div>

                                    <button
                                        onClick={handleNextPage}
                                        disabled={pagination.currentPage === pagination.totalPages}
                                        className={`px-4 py-2 border rounded-lg text-sm font-medium transition-colors ${pagination.currentPage === pagination.totalPages
                                            ? "bg-gray-100 text-gray-400 cursor-not-allowed"
                                            : "bg-white text-gray-700 border-gray-300 hover:bg-gray-50"
                                            }`}
                                    >
                                        Next
                                    </button>
                                </div>
                            </div>
                        )}
                    </div>
                ) : (
                    <div className="text-center py-20">
                        <div className="bg-gray-50 w-16 h-16 rounded-2xl flex items-center justify-center mx-auto mb-4">
                            <FiUser className="text-2xl text-gray-200" />
                        </div>
                        <h2 className="text-lg font-bold text-gray-800">No candidates found</h2>
                        <p className="text-xs text-gray-400 mt-1">No candidates matching your filters</p>
                    </div>
                )}
            </div>

            {/* Invite Modal */}
            {isInviteModalOpen && (
                <div className="fixed inset-0 z-[100] flex items-center justify-center p-4 bg-gray-900/40 backdrop-blur-[2px] animate-in fade-in duration-200">
                    <div className="bg-white w-full max-w-md rounded-2xl shadow-2xl overflow-hidden relative animate-in slide-in-from-bottom-4 duration-300 border border-gray-100">

                        {/* Close Button */}
                        <button
                            onClick={() => setIsInviteModalOpen(false)}
                            className="absolute top-4 right-4 p-2 text-gray-400 hover:text-gray-800 hover:bg-gray-100 rounded-xl transition-all"
                        >
                            <FiX className="text-lg" />
                        </button>

                        {/* Header */}
                        <div className="px-8 pt-8 pb-4">
                            <h2 className="text-xl text-gray-800">
                                Send Interview Invite
                            </h2>
                            <p className="text-[10px] font-bold uppercase tracking-widest mt-1">
                                Schedule interview for candidate
                            </p>
                        </div>

                        {/* Body */}
                        <div className="p-8 pt-4">
                            <p className="text-sm text-gray-600 mb-4">
                                Candidate: <span className="font-semibold text-gray-800">{selectedCandidate?.firstName} {selectedCandidate?.lastName}</span>
                            </p>

                            <div className="space-y-4">
                                <div>
                                    <label className="block text-sm font-medium text-gray-700 mb-1">Subject</label>
                                    <input
                                        type="text"
                                        className="w-full p-2 border rounded focus:ring-2 focus:ring-blue-500"
                                        value={inviteForm.subject}
                                        onChange={(e) => setInviteForm({ ...inviteForm, subject: e.target.value })}
                                    />
                                </div>
                                <div>
                                    <label className="block text-sm font-medium text-gray-700 mb-1">Interview Time & Date</label>
                                    <input
                                        type="datetime-local"
                                        className="w-full p-2 border rounded focus:ring-2 focus:ring-blue-500"
                                        value={inviteForm.time}
                                        onChange={(e) => setInviteForm({ ...inviteForm, time: e.target.value })}
                                    />
                                </div>
                                <div>
                                    <label className="block text-sm font-medium text-gray-700 mb-1">Interview Mode / Location</label>
                                    <select
                                        className="w-full p-2 border rounded focus:ring-2 focus:ring-blue-500 font-bold text-sm"
                                        value={inviteForm.interviewMode}
                                        onChange={(e) => setInviteForm({ ...inviteForm, interviewMode: e.target.value })}
                                    >
                                        <option value="Online">🌐 Online (Google Meet / Zoom)</option>
                                        {locations.map(loc => (
                                            <option key={loc._id} value={loc.fullAddress}>
                                                📍 {loc.name} - {loc.fullAddress}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                            </div>

                            <div className="flex justify-end gap-3 mt-6">
                                <button
                                    className="px-4 py-2 text-gray-600 hover:bg-gray-100 rounded"
                                    onClick={() => setIsInviteModalOpen(false)}
                                >
                                    Cancel
                                </button>
                                <button
                                    className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700 shadow-lg"
                                    onClick={handleSendInvite}
                                >
                                    Send Invitation
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {/* Document Management Modal */}
            {isDocsModalOpen && (
                <div className="fixed inset-0 z-[100] flex items-center justify-center p-4 bg-gray-900/40 backdrop-blur-[2px] animate-in fade-in duration-200">
                    <div className="bg-white w-full max-w-2xl rounded-2xl shadow-2xl overflow-hidden relative animate-in slide-in-from-bottom-4 duration-300 border border-gray-100">

                        {/* Close Button */}
                        <button
                            onClick={() => setIsDocsModalOpen(false)}
                            className="absolute top-4 right-4 p-2 text-gray-400 hover:text-gray-800 hover:bg-gray-100 rounded-xl transition-all"
                        >
                            <FiX className="text-lg" />
                        </button>

                        {/* Header */}
                        <div className="px-8 pt-8 pb-4">
                            <h2 className="text-xl text-gray-800">
                                Document Management
                            </h2>
                            <p className="text-[10px] font-bold uppercase tracking-widest mt-1">
                                Review Status: {selectedCandidate?.docReviewStatus}
                            </p>
                        </div>

                        {/* Body */}
                        <div className="p-8 pt-4 space-y-6 max-h-[70vh] overflow-y-auto">
                            {/* Step 1: Send Agreements */}
                            <div className="bg-gray-50 p-4 rounded-lg border border-gray-200">
                                <h3 className="text-sm font-black uppercase text-gray-700 mb-3 tracking-wider">Step 1: Agreements for Candidate</h3>
                                <textarea
                                    className="w-full p-3 border rounded-md text-sm min-h-[150px] focus:ring-2 focus:ring-indigo-500"
                                    placeholder="Enter agreement terms or instructions..."
                                    value={docsForm.agreementsContent}
                                    onChange={(e) => setDocsForm({ ...docsForm, agreementsContent: e.target.value })}
                                />
                                <div className="mt-3">
                                    <label className="block text-xs font-bold text-gray-500 mb-1 uppercase">Attach Agreement Check (PDF/Doc)</label>
                                    <input
                                        type="file"
                                        className="w-full text-xs text-gray-500 file:mr-4 file:py-2 file:px-4 file:rounded-full file:border-0 file:text-xs file:font-semibold file:bg-indigo-50 file:text-indigo-700 hover:file:bg-indigo-100"
                                        onChange={(e) => setDocsFile(e.target.files[0])}
                                    />
                                </div>
                                <button
                                    onClick={handleSendAgreements}
                                    className="mt-3 px-6 py-2 bg-indigo-600 text-white rounded text-xs font-bold uppercase tracking-widest hover:bg-indigo-700"
                                >
                                    Send / Update Agreements
                                </button>
                            </div>

                            {/* Step 2: Review Candidate Upload */}
                            {selectedCandidate?.candidateAgreementsUpload && (
                                <div className="bg-blue-50 p-4 rounded-lg border border-blue-200">
                                    <h3 className="text-sm font-black uppercase text-blue-800 mb-3 tracking-wider">Step 2: Review Uploaded Document</h3>
                                    <div className="flex items-center justify-between bg-white p-3 rounded border border-blue-100 mb-4">
                                        <div className="flex items-center gap-2">
                                            <span className="text-xs font-bold text-gray-700">Signed_Agreement.pdf</span>
                                        </div>
                                    </div>
                                    <div className="flex gap-2">
                                        <button
                                            onClick={() => window.open(formatDocUrl(selectedCandidate.candidateAgreementsUpload), "_blank")}
                                            className="flex-1 px-6 py-2 bg-indigo-600 text-white rounded-lg text-xs font-black uppercase tracking-widest shadow-lg hover:bg-indigo-700 transition-all active:scale-95 flex items-center justify-center gap-2"
                                        >
                                            <FiEye size={14} /> View
                                        </button>
                                        <button
                                            onClick={() => {
                                                const link = document.createElement('a');
                                                link.href = formatDocUrl(selectedCandidate.candidateAgreementsUpload);
                                                link.download = `Signed_Agreement_${selectedCandidate.firstName}.pdf`;
                                                document.body.appendChild(link);
                                                link.click();
                                                document.body.removeChild(link);
                                            }}
                                            className="flex-1 px-6 py-2 bg-emerald-600 text-white rounded-lg text-xs font-black uppercase tracking-widest shadow-lg hover:bg-emerald-700 transition-all active:scale-95 flex items-center justify-center gap-2"
                                        >
                                            <FiDownload size={14} /> Download
                                        </button>
                                    </div>
                                    <div className="flex gap-2 mt-4">
                                        <button
                                            onClick={() => handleReviewDocs("Accepted")}
                                            className="flex-1 py-2 bg-green-600 text-white rounded text-xs font-bold uppercase tracking-widest hover:bg-green-700 shadow-md"
                                        >
                                            Accept Documents
                                        </button>
                                        <button
                                            onClick={() => handleReviewDocs("Rejected")}
                                            className="flex-1 py-2 bg-red-600 text-white rounded text-xs font-bold uppercase tracking-widest hover:bg-red-700 shadow-md"
                                        >
                                            Reject & Resubmit
                                        </button>
                                    </div>
                                </div>
                            )}

                            {!selectedCandidate?.candidateAgreementsUpload && (
                                <div className="text-center p-8 bg-gray-50 rounded-lg border border-dashed border-gray-300">
                                    <p className="text-xs font-bold text-gray-400 uppercase">Awaiting candidate upload...</p>
                                </div>
                            )}

                            {/* Step 3: Personal Documents & Details */}
                            <div className="bg-white p-4 rounded-lg border border-gray-200">
                                <h3 className="text-sm font-black uppercase text-gray-700 mb-4 tracking-wider flex items-center gap-2">
                                    <FiFileText className="text-blue-500" /> Step 3: Personal Documents & Details
                                </h3>

                                {personalDocsLoading ? (
                                    <div className="flex items-center justify-center p-8">
                                        <div className="w-6 h-6 border-2 border-indigo-600 border-t-transparent rounded-full animate-spin"></div>
                                        <p className="ml-3 text-xs font-bold text-gray-400 uppercase tracking-widest">Fetching Docs...</p>
                                    </div>
                                ) : personalDocs ? (
                                    <div className="space-y-6">
                                        {/* Document Grid */}
                                        <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
                                            {[
                                                { title: "Aadhar Card", type: "aadharCard" },
                                                { title: "PAN Card", type: "panCard" },
                                                { title: "10th Certificate", type: "tenthCertificate" },
                                                { title: "12th Certificate", type: "twelfthCertificate" },
                                                { title: "Graduation", type: "graduationCertificate" },
                                                { title: "Passport Photo", type: "passportPhoto" },
                                                { title: "Exp. Letters", type: "experienceLetters" }
                                            ].map((cat) => {
                                                const doc = personalDocs.documents?.[cat.type];
                                                const isUploaded = !!doc?.url;
                                                return (
                                                    <div key={cat.type} className={`p-3 rounded-xl border flex items-center justify-between transition-all ${isUploaded ? "bg-emerald-50/30 border-emerald-100" : "bg-gray-50 border-gray-100"}`}>
                                                        <div className="flex items-center gap-2">
                                                            <div className={`p-2 rounded-lg ${isUploaded ? "bg-emerald-100 text-emerald-600" : "bg-gray-100 text-gray-400"}`}>
                                                                <FiFileText size={14} />
                                                            </div>
                                                            <div>
                                                                <p className="text-[10px] font-bold text-gray-800 uppercase tracking-tight">{cat.title}</p>
                                                                {isUploaded ? (
                                                                    <p className="text-[8px] font-bold text-emerald-600 uppercase tracking-widest flex items-center gap-1">
                                                                        <FiCheckCircle size={8} /> Uploaded
                                                                    </p>
                                                                ) : (
                                                                    <p className="text-[8px] font-bold text-gray-400 uppercase tracking-widest flex items-center gap-1">
                                                                        <FiAlertTriangle size={8} /> Missing
                                                                    </p>
                                                                )}
                                                            </div>
                                                        </div>
                                                        {isUploaded && (
                                                            <div className="flex gap-1">
                                                                <button
                                                                    onClick={() => window.open(formatDocUrl(doc.url), '_blank')}
                                                                    className="px-3 py-1 bg-white border border-slate-200 text-slate-700 rounded-lg text-[9px] font-black uppercase tracking-widest hover:bg-slate-600 hover:text-white transition-all shadow-sm"
                                                                    title="View"
                                                                >
                                                                    <FiEye size={10} />
                                                                </button>
                                                                <button
                                                                    onClick={() => {
                                                                        const link = document.createElement('a');
                                                                        link.href = formatDocUrl(doc.url);
                                                                        link.download = `${cat.title}_${selectedCandidate.firstName}.pdf`;
                                                                        document.body.appendChild(link);
                                                                        link.click();
                                                                        document.body.removeChild(link);
                                                                    }}
                                                                    className="px-3 py-1 bg-white border border-emerald-200 text-emerald-700 rounded-lg text-[9px] font-black uppercase tracking-widest hover:bg-emerald-600 hover:text-white transition-all shadow-sm"
                                                                    title="Download"
                                                                >
                                                                    <FiDownload size={10} />
                                                                </button>
                                                            </div>
                                                        )}
                                                    </div>
                                                );
                                            })}
                                        </div>

                                        {/* Bank Details */}
                                        <div className="p-4 bg-blue-50/50 rounded-xl border border-blue-100">
                                            <h4 className="text-[10px] font-black uppercase text-blue-700 mb-3 tracking-widest flex items-center gap-2">
                                                <FiAward /> Bank Details
                                            </h4>
                                            {personalDocs.documents?.bankDetails?.bankName ? (
                                                <div className="grid grid-cols-3 gap-4">
                                                    <div>
                                                        <p className="text-[9px] font-bold text-gray-400 uppercase mb-1">Bank Name</p>
                                                        <p className="text-xs font-bold text-gray-800 uppercase">{personalDocs.documents.bankDetails.bankName}</p>
                                                    </div>
                                                    <div>
                                                        <p className="text-[9px] font-bold text-gray-400 uppercase mb-1">A/C Number</p>
                                                        <p className="text-xs font-bold text-gray-800 font-mono tracking-wider">
                                                            {personalDocs.documents.bankDetails.accountNumber}
                                                        </p>
                                                    </div>
                                                    <div>
                                                        <p className="text-[9px] font-bold text-gray-400 uppercase mb-1">IFSC Code</p>
                                                        <p className="text-xs font-bold text-gray-800 tracking-widest">{personalDocs.documents.bankDetails.ifscCode}</p>
                                                    </div>
                                                </div>
                                            ) : (
                                                <p className="text-center py-2 text-[9px] font-bold text-blue-400 uppercase italic">Bank info not provided yet</p>
                                            )}
                                        </div>

                                        {/* Emergency Contact */}
                                        <div className="p-4 bg-rose-50/50 rounded-xl border border-rose-100">
                                            <h4 className="text-[10px] font-black uppercase text-rose-700 mb-3 tracking-widest flex items-center gap-2">
                                                <FiUsers /> Emergency Contacts
                                            </h4>
                                            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                                                {[1, 2].map(num => {
                                                    const contact = personalDocs.documents?.[`emergencyContact${num}`];
                                                    return (
                                                        <div key={num} className="bg-white/60 p-3 rounded-lg border border-rose-100/50">
                                                            <p className="text-[8px] font-black text-rose-400 uppercase mb-2 tracking-widest">Contact #{num}</p>
                                                            {contact?.name ? (
                                                                <div className="space-y-1">
                                                                    <p className="text-xs font-bold text-gray-800 uppercase">{contact.name}</p>
                                                                    <div className="flex items-center justify-between">
                                                                        <p className="text-[10px] font-bold text-gray-500 font-mono">{contact.phone}</p>
                                                                        <span className="text-[9px] font-bold text-rose-600 bg-rose-100 px-2 py-0.5 rounded uppercase">{contact.relationship}</span>
                                                                    </div>
                                                                </div>
                                                            ) : (
                                                                <p className="text-[9px] font-bold text-rose-300 uppercase italic">Contact {num} not provided</p>
                                                            )}
                                                        </div>
                                                    );
                                                })}
                                            </div>
                                        </div>
                                    </div>
                                ) : (
                                    <div className="text-center p-12 bg-gray-50 rounded-lg border border-dashed border-gray-200">
                                        <div className="w-12 h-12 bg-white rounded-full flex items-center justify-center mx-auto mb-3 shadow-sm text-gray-300">
                                            <FiAlertTriangle size={24} />
                                        </div>
                                        <p className="text-[10px] font-bold text-gray-400 uppercase tracking-widest">No Personal documents records found</p>
                                        <p className="text-[8px] text-gray-400 mt-1 uppercase italic tracking-tighter">Candidate may not have started the document upload process yet</p>
                                    </div>
                                )}
                            </div>
                        </div>

                        <div className="flex justify-end mt-6">
                            <button
                                className="px-6 py-2 text-slate-500 font-bold text-xs uppercase tracking-widest hover:bg-slate-100 rounded"
                                onClick={() => setIsDocsModalOpen(false)}
                            >
                                Close
                            </button>
                        </div>
                    </div>
                </div>
            )}

            {/* Assessment Detail Modal */}
            {isAssessmentModalOpen && selectedAssessmentData && (
                <div className="fixed inset-0 z-[100] flex items-center justify-center p-4 bg-gray-900/40 backdrop-blur-[2px] animate-in fade-in duration-200">
                    <div className="bg-white max-w-4xl w-full rounded-2xl shadow-2xl overflow-hidden relative animate-in slide-in-from-bottom-4 duration-300 border border-gray-100 max-h-[90vh] flex flex-col">

                        <div className="px-8 pt-8 pb-6 border-b border-gray-100 flex-shrink-0">
                            <div className="flex items-start justify-between">
                                <div>
                                    <h2 className="text-xl text-gray-800 font-bold flex items-center gap-2">
                                        Assessment Answer Sheets
                                    </h2>
                                    <p className="text-[10px] font-bold uppercase tracking-widest mt-1.5 text-gray-500">
                                        Candidate: <span className="text-indigo-600">{selectedCandidate?.firstName} {selectedCandidate?.lastName}</span>
                                    </p>
                                </div>
                                <button
                                    onClick={() => setIsAssessmentModalOpen(false)}
                                    className="p-2 text-gray-400 hover:text-gray-800 hover:bg-gray-100 rounded-xl transition-all"
                                >
                                    <FiX className="text-lg" />
                                </button>
                            </div>
                        </div>

                        <div className="p-8 overflow-y-auto space-y-12 flex-grow bg-white">
                            {Array.isArray(selectedAssessmentData) && selectedAssessmentData.length > 0 ? (
                                selectedAssessmentData.map((assessment, aIdx) => (
                                    <div key={aIdx} className="space-y-6">
                                        <div className="flex items-center justify-between pb-2 border-b-2 border-indigo-100">
                                            <h3 className="text-lg font-black text-indigo-900">{assessment.quizTitle}</h3>
                                            <div className="flex items-center gap-4">
                                                <div className="flex items-center gap-1">
                                                    <span className="text-[10px] font-bold text-gray-400 uppercase tracking-widest">Score:</span>
                                                    <span className={`text-sm font-black ${assessment.score >= 70 ? 'text-emerald-600' : assessment.score >= 50 ? 'text-amber-600' : 'text-rose-600'}`}>
                                                        {assessment.score}
                                                    </span>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="space-y-6">
                                            {assessment.answers && assessment.answers.length > 0 ? (
                                                assessment.answers.map((ans, idx) => {
                                                    const optionLabels = ["A", "B", "C", "D", "E", "F", "G", "H"];
                                                    const options = ans.options && ans.options.length > 0
                                                        ? ans.options
                                                        : [ans.selectedOption, ans.correctAnswer].filter(Boolean);

                                                    return (
                                                        <div key={idx} className="bg-white rounded-xl border border-gray-200 shadow-[0_2px_10px_-3px_rgba(6,81,237,0.1)] overflow-hidden">
                                                            <div className="flex items-start gap-3 px-5 py-4 border-b border-gray-100 bg-gray-50/50">
                                                                <div className={`w-8 h-8 rounded-lg flex items-center justify-center shrink-0 font-black text-xs ${ans.isCorrect ? 'bg-emerald-100 text-emerald-600' : 'bg-rose-100 text-rose-600'}`}>
                                                                    Q{idx + 1}
                                                                </div>
                                                                <div className="flex-grow pt-1">
                                                                    <p className="text-sm font-bold text-gray-800 leading-relaxed">{ans.questionText}</p>
                                                                </div>
                                                                <div className="shrink-0 pt-1.5 flex items-center gap-1.5">
                                                                    {ans.isCorrect ? (
                                                                        <span className="text-[10px] font-black uppercase text-emerald-600 flex items-center gap-1">✓ Correct</span>
                                                                    ) : (
                                                                        <span className="text-[10px] font-black uppercase text-rose-600 flex items-center gap-1">✗ Incorrect</span>
                                                                    )}
                                                                </div>
                                                            </div>

                                                            <div className="p-5 space-y-2.5">
                                                                {options.map((opt, oIdx) => {
                                                                    const isCorrectOpt = String(opt).trim() === String(ans.correctAnswer).trim();
                                                                    const isCandidateOpt = String(opt).trim() === String(ans.selectedOption).trim();
                                                                    const label = optionLabels[oIdx] || String(oIdx + 1);

                                                                    let optStyle = "bg-white border-gray-200 text-gray-600";
                                                                    let radioStyle = "border-gray-200 border-2";
                                                                    let badge = null;

                                                                    if (isCorrectOpt && isCandidateOpt) {
                                                                        optStyle = "bg-emerald-50/50 border-emerald-300 text-emerald-800";
                                                                        radioStyle = "border-emerald-500 bg-emerald-500";
                                                                        badge = <span className="text-[9px] font-black text-emerald-600 bg-emerald-100 px-2.5 py-1 rounded text-right uppercase tracking-wider">✓ Selected Correctly</span>;
                                                                    } else if (isCorrectOpt) {
                                                                        optStyle = "bg-emerald-50/30 border-emerald-200 text-emerald-700 border-dashed";
                                                                        radioStyle = "border-emerald-400 border-2";
                                                                        badge = <span className="text-[9px] font-black text-emerald-600 bg-emerald-100 px-2.5 py-1 rounded text-right uppercase tracking-wider">✓ Correct Answer</span>;
                                                                    } else if (isCandidateOpt) {
                                                                        optStyle = "bg-rose-50/50 border-rose-300 text-rose-800";
                                                                        radioStyle = "border-rose-500 bg-rose-500";
                                                                        badge = <span className="text-[9px] font-black text-rose-600 bg-rose-100 px-2.5 py-1 rounded text-right uppercase tracking-wider">✗ Selected Incorrectly</span>;
                                                                    }

                                                                    return (
                                                                        <div key={oIdx} className={`flex items-center gap-4 px-4 py-3 rounded-xl border transition-all ${optStyle}`}>
                                                                            <div className="shrink-0">
                                                                                <span className="text-[10px] font-black text-gray-400 bg-gray-50 border border-gray-100 px-2 py-0.5 rounded uppercase">{label}</span>
                                                                            </div>

                                                                            <div className={`w-4 h-4 rounded-full flex items-center justify-center shrink-0 ${radioStyle}`}>
                                                                                {(isCandidateOpt || isCorrectOpt) && (
                                                                                    <div className={`w-1.5 h-1.5 rounded-full ${isCorrectOpt && !isCandidateOpt ? 'bg-emerald-400' : 'bg-white'}`} />
                                                                                )}
                                                                            </div>

                                                                            <p className="text-xs font-semibold flex-grow">{opt}</p>

                                                                            {badge && (
                                                                                <div className="shrink-0 flex items-center justify-end min-w-[120px]">
                                                                                    {badge}
                                                                                </div>
                                                                            )}
                                                                        </div>
                                                                    );
                                                                })}
                                                            </div>
                                                        </div>
                                                    );
                                                })
                                            ) : (
                                                <p className="text-xs text-gray-500 italic">No detailed answers available for this assessment.</p>
                                            )}
                                        </div>
                                    </div>
                                ))
                            ) : (
                                <div className="text-center py-20 bg-gray-50 rounded-xl border border-gray-100 flex flex-col items-center justify-center">
                                    <div className="w-16 h-16 bg-white text-gray-300 rounded-full flex items-center justify-center mb-4 border border-gray-100 shadow-sm">
                                        <FiEye className="text-3xl" />
                                    </div>
                                    <p className="text-gray-800 font-bold mb-1">No detailed analysis available</p>
                                    <p className="text-gray-400 text-[10px] font-black uppercase tracking-widest max-w-xs">Old assessment record without question tracking</p>
                                </div>
                            )}
                        </div>

                        <div className="px-8 py-4 border-t border-gray-100 bg-gray-50 flex justify-end flex-shrink-0">
                            <button
                                onClick={() => setIsAssessmentModalOpen(false)}
                                className="px-6 py-2.5 bg-white border border-gray-200 text-gray-700 hover:bg-gray-100 hover:text-gray-900 rounded-lg font-bold text-xs uppercase tracking-widest transition-all shadow-[0_2px_4px_rgba(0,0,0,0.02)]"
                            >
                                Close View
                            </button>
                        </div>
                    </div>
                </div>
            )}

            {/* Salary Package Modal */}
            {isPackageModalOpen && (
                <div className="fixed inset-0 z-[100] flex items-center justify-center p-4 bg-black/50 backdrop-blur-sm">
                    <div className="bg-white rounded-2xl max-w-2xl w-full p-6 shadow-2xl relative animate-in fade-in zoom-in duration-300">
                        <button
                            onClick={() => setIsPackageModalOpen(false)}
                            className="absolute top-4 right-4 p-2 text-gray-400 hover:text-gray-600 hover:bg-gray-100 rounded-full transition-all"
                        >
                            <FiX />
                        </button>

                        <div className="text-center mb-8">
                            <div className="w-16 h-16 bg-blue-100 text-blue-600 rounded-full flex items-center justify-center mx-auto mb-4">
                                <FiBriefcase size={28} />
                            </div>
                            <h2 className="text-2xl font-black text-gray-800">Salary Package</h2>
                            <p className="text-gray-400 text-[10px] font-black uppercase tracking-widest mt-1">Negotiation & Finalization</p>
                        </div>

                        <div className="space-y-4">
                            <div className="grid grid-cols-2 gap-4">
                                <div className="p-4 bg-gray-50 rounded-xl border border-gray-100">
                                    <p className="text-[9px] font-black text-gray-400 uppercase tracking-widest mb-1">Budget Salary</p>
                                    <p className="text-sm font-bold text-gray-800">{selectedCandidate?.jobId?.salary || "N/A"}</p>
                                </div>
                                <div className="p-4 bg-gray-50 rounded-xl border border-gray-100">
                                    <p className="text-[9px] font-black text-gray-400 uppercase tracking-widest mb-1">Previous Salary</p>
                                    <p className="text-sm font-bold text-gray-800">{selectedCandidate?.currentCTC || "N/A"}</p>
                                </div>
                            </div>

                            <div className="grid grid-cols-2 gap-4">
                                <div>
                                    <label className="block text-[10px] font-black text-gray-500 uppercase tracking-widest mb-2 px-1">Final Agreed Salary</label>
                                    <div className="relative">
                                        <div className="absolute left-4 top-1/2 -translate-y-1/2 text-gray-400 font-bold">₹</div>
                                        <input
                                            type="text"
                                            placeholder="e.g. 12,00,000"
                                            className="w-full pl-10 pr-4 py-3 bg-gray-50 border border-gray-200 rounded-2xl focus:ring-4 focus:ring-blue-500/10 focus:border-blue-500 transition-all font-bold text-gray-800"
                                            value={packageSalary}
                                            onChange={(e) => setPackageSalary(e.target.value)}
                                        />
                                    </div>
                                </div>

                                <div>
                                    <label className="block text-[10px] font-black text-gray-500 uppercase tracking-widest mb-2 px-1">Joining Date</label>
                                    <div className="relative">
                                        <input
                                            type="date"
                                            className="w-full px-4 py-3 bg-gray-50 border border-gray-200 rounded-2xl focus:ring-4 focus:ring-blue-500/10 focus:border-blue-500 transition-all font-bold text-gray-800"
                                            value={packageJoiningDate}
                                            onChange={(e) => setPackageJoiningDate(e.target.value)}
                                            onClick={(e) => e.target.showPicker && e.target.showPicker()}
                                        />
                                    </div>
                                </div>
                            </div>

                            <div className="grid grid-cols-2 gap-4">
                                <div>
                                    <label className="block text-[10px] font-black text-gray-500 uppercase tracking-widest mb-2 px-1">Notice Period</label>
                                    <select
                                        className="w-full px-4 py-3 bg-gray-50 border border-gray-200 rounded-2xl focus:ring-4 focus:ring-blue-500/10 focus:border-blue-500 transition-all font-bold text-gray-800 appearance-none"
                                        value={packageNoticePeriod}
                                        onChange={(e) => setPackageNoticePeriod(e.target.value)}
                                    >
                                        <option value="">Select Notice Period</option>
                                        <option value="10 Days">10 Days</option>
                                        <option value="15 Days">15 Days</option>
                                        <option value="20 Days">20 Days</option>
                                        <option value="30 Days">30 Days</option>
                                        <option value="60 Days">60 Days</option>
                                    </select>
                                </div>
                                <div>
                                    <label className="block text-[10px] font-black text-gray-500 uppercase tracking-widest mb-2 px-1">Probation Period</label>
                                    <input
                                        type="text"
                                        placeholder="e.g. 6 Months"
                                        className="w-full px-4 py-3 bg-gray-50 border border-gray-200 rounded-2xl focus:ring-4 focus:ring-blue-500/10 focus:border-blue-500 transition-all font-bold text-gray-800"
                                        value={packageProbationPeriod}
                                        onChange={(e) => setPackageProbationPeriod(e.target.value)}
                                    />
                                </div>
                            </div>

                            <div className="grid grid-cols-2 gap-4">
                                <div>
                                    <label className="block text-[10px] font-black text-gray-500 uppercase tracking-widest mb-2 px-1">Daily Allowance (Optional)</label>
                                    <input
                                        type="text"
                                        placeholder="e.g. ₹500 or NA"
                                        className="w-full px-4 py-3 bg-gray-50 border border-gray-200 rounded-2xl focus:ring-4 focus:ring-blue-500/10 focus:border-blue-500 transition-all font-bold text-gray-800"
                                        value={packageDailyAllowance}
                                        onChange={(e) => setPackageDailyAllowance(e.target.value)}
                                    />
                                </div>
                                <div>
                                    <label className="block text-[10px] font-black text-gray-500 uppercase tracking-widest mb-2 px-1">Perf. Allowance (Optional)</label>
                                    <input
                                        type="text"
                                        placeholder="e.g. ₹2000 or NA"
                                        className="w-full px-4 py-3 bg-gray-50 border border-gray-200 rounded-2xl focus:ring-4 focus:ring-blue-500/10 focus:border-blue-500 transition-all font-bold text-gray-800"
                                        value={packagePerformanceAllowance}
                                        onChange={(e) => setPackagePerformanceAllowance(e.target.value)}
                                    />
                                </div>
                            </div>

                            <p className="text-[9px] text-gray-400 mt-1 px-1 font-medium italic">* These values will be used in the official offer letter.</p>

                            <button
                                onClick={handleSavePackage}
                                className="w-full py-3 bg-gradient-to-r from-blue-600 to-indigo-700 text-white rounded-2xl font-black text-xs uppercase tracking-[0.2em] shadow-lg shadow-blue-200 hover:shadow-blue-300 hover:-translate-y-0.5 transition-all duration-300 mt-2"
                            >
                                Save Package Details
                            </button>
                        </div>
                    </div>
                </div>
            )}

            {/* Candidate Details Modal */}
            {isDetailsModalOpen && selectedCandidate && (
                <div className="fixed inset-0 z-[110] flex items-center justify-center p-4 bg-black/60 backdrop-blur-md transition-all duration-300">
                    <div className="bg-white rounded-[2.5rem] max-w-2xl w-full p-0 shadow-2xl relative overflow-hidden animate-in fade-in zoom-in duration-300">
                        {/* Header with Gradient */}
                        <div className="bg-gradient-to-r from-blue-600 to-indigo-700 p-8 text-white relative">
                            <button
                                onClick={() => setIsDetailsModalOpen(false)}
                                className="absolute top-6 right-6 p-2 bg-white/10 hover:bg-white/20 text-white rounded-full transition-all"
                            >
                                <FiX size={18} />
                            </button>
                            <div className="flex items-center gap-6">
                                <div className="w-20 h-20 bg-white/20 backdrop-blur-sm rounded-2xl flex items-center justify-center border border-white/30">
                                    <FiUser size={36} className="text-white" />
                                </div>
                                <div>
                                    <h2 className="text-3xl font-black">{selectedCandidate.firstName} {selectedCandidate.lastName}</h2>
                                    <div className="flex items-center gap-2 mt-2">
                                        <span className="px-3 py-1 bg-white/20 rounded-full text-[10px] font-black uppercase tracking-widest border border-white/20">
                                            {selectedCandidate.jobId?.role || "Candidate"}
                                        </span>
                                        <span className="px-3 py-1 bg-emerald-500/20 text-emerald-100 rounded-full text-[10px] font-black uppercase tracking-widest border border-emerald-500/30">
                                            {selectedCandidate.status}
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* Content Area */}
                        <div className="p-10 max-h-[70vh] overflow-y-auto custom-scrollbar">
                            <div className="grid grid-cols-2 gap-10">
                                {/* Contact Section */}
                                <div className="space-y-8">
                                    <h3 className="text-xs font-black text-blue-600 uppercase tracking-[0.2em] flex items-center gap-2">
                                        <div className="w-1.5 h-1.5 bg-blue-600 rounded-full"></div>
                                        Contact Information
                                    </h3>
                                    <div className="space-y-6">
                                        <DetailItem
                                            icon={<FiMail size={18} />}
                                            label="Email Address"
                                            value={selectedCandidate.email}
                                        />
                                        <DetailItem
                                            icon={<FiPhone size={18} />}
                                            label="Mobile Number"
                                            value={selectedCandidate.mobile}
                                        />
                                        <DetailItem
                                            icon={<FiMapPin size={18} />}
                                            label="Postal Address"
                                            value={selectedCandidate.address || "N/A"}
                                        />
                                    </div>
                                </div>

                                {/* Package Section */}
                                <div className="space-y-8">
                                    <h3 className="text-xs font-black text-indigo-600 uppercase tracking-[0.2em] flex items-center gap-2">
                                        <div className="w-1.5 h-1.5 bg-indigo-600 rounded-full"></div>
                                        Package Details
                                    </h3>
                                    <div className="space-y-6 p-6 bg-gray-50 rounded-3xl border border-gray-100">
                                        <DetailItem
                                            icon={<FiBriefcase size={18} className="text-indigo-500" />}
                                            label="Final Agreed Salary"
                                            value={selectedCandidate.finalSalary ? `₹${selectedCandidate.finalSalary}` : "Negotiation Pending"}
                                        />
                                        <DetailItem
                                            icon={<FiCalendar size={18} className="text-indigo-500" />}
                                            label="Date of Joining"
                                            value={selectedCandidate.dateOfJoining || "To be decided"}
                                        />
                                    </div>
                                </div>
                            </div>

                            {/* Additional Status or Footer info */}
                            <div className="mt-12 p-6 bg-blue-50/50 rounded-2xl border border-blue-100/50 flex items-center justify-between">
                                <div className="flex items-center gap-3">
                                    <div className="w-10 h-10 bg-blue-100 rounded-full flex items-center justify-center text-blue-600 font-black text-xs">ID</div>
                                    <div>
                                        <p className="text-[9px] font-black text-gray-400 uppercase tracking-[0.2em]">Application Reference</p>
                                        <p className="text-xs font-bold text-gray-700">{selectedCandidate._id}</p>
                                    </div>
                                </div>
                                <button
                                    onClick={() => setIsDetailsModalOpen(false)}
                                    className="px-6 py-2 bg-white text-gray-700 border border-gray-200 rounded-xl font-black text-[10px] uppercase tracking-widest hover:bg-gray-50 transition-all shadow-sm"
                                >
                                    Close Details
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {/* Document History Modal */}
            {isHistoryModalOpen && selectedCandidate && (
                <div className="fixed inset-0 z-[120] flex items-center justify-center p-4 bg-gray-900/40 backdrop-blur-[2px] animate-in fade-in duration-200">
                    <div className="bg-white w-full max-w-4xl rounded-2xl shadow-2xl overflow-hidden relative animate-in slide-in-from-bottom-4 duration-300 border border-gray-100">

                        {/* Close Button */}
                        <button
                            onClick={() => setIsHistoryModalOpen(false)}
                            className="absolute top-4 right-4 p-2 text-gray-400 hover:text-gray-800 hover:bg-gray-100 rounded-xl transition-all"
                        >
                            <FiX className="text-lg" />
                        </button>

                        {/* Header */}
                        <div className="px-8 pt-8 pb-4">
                            <h2 className="text-xl text-gray-800">
                                Document Sent History
                            </h2>
                            <p className="text-[10px] font-bold uppercase tracking-widest mt-1">
                                Candidate: {selectedCandidate.firstName} {selectedCandidate.lastName}
                            </p>
                        </div>

                        {/* Body */}
                        <div className="p-8 pt-4 max-h-[70vh] overflow-y-auto">
                            {selectedCandidate.documentHistory && selectedCandidate.documentHistory.length > 0 ? (
                                <div className="space-y-4">
                                    {selectedCandidate.documentHistory.map((item, index) => (
                                        <div key={item._id || index} className="p-4 bg-gray-50 rounded-2xl border border-gray-100 flex items-center justify-between group hover:bg-white hover:shadow-lg transition-all duration-300">
                                            <div className="flex items-center gap-4">
                                                <div className={`w-12 h-12 rounded-xl flex items-center justify-center text-lg ${item.documentType === 'Offer' ? 'bg-green-100 text-green-600' :
                                                        item.documentType === 'Agreement' ? 'bg-blue-100 text-blue-600' :
                                                            'bg-gray-100 text-gray-600'
                                                    }`}>
                                                    <FiFileText />
                                                </div>
                                                <div>
                                                    <div className="flex items-center gap-2">
                                                        <span className="text-sm font-black text-gray-800 uppercase tracking-tight">{item.documentType} Letter</span>
                                                        <span className="text-[10px] font-bold text-gray-400">Sent on {new Date(item.sentAt).toLocaleDateString()} at {new Date(item.sentAt).toLocaleTimeString()}</span>
                                                    </div>
                                                    <div className="mt-1 text-xs text-gray-500 line-clamp-1 max-w-md italic">
                                                        "{item.content?.replace(/<[^>]*>?/gm, '').substring(0, 100)}..."
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="flex items-center gap-2">
                                                {item.attachmentPath && (
                                                    <>
                                                        <button
                                                            onClick={() => window.open(formatDocUrl(item.attachmentPath), "_blank")}
                                                            className="px-4 py-2 bg-gray-100 text-gray-600 rounded-xl text-[10px] font-black uppercase tracking-widest hover:bg-gray-200 transition-all flex items-center gap-2"
                                                            title="View Document"
                                                        >
                                                            <FiEye size={12} /> View
                                                        </button>
                                                        <button
                                                            onClick={() => {
                                                                const link = document.createElement('a');
                                                                link.href = formatDocUrl(item.attachmentPath);
                                                                link.download = `${item.documentType}_Letter.pdf`;
                                                                document.body.appendChild(link);
                                                                link.click();
                                                                document.body.removeChild(link);
                                                            }}
                                                            className="px-4 py-2 bg-emerald-50 text-emerald-600 rounded-xl text-[10px] font-black uppercase tracking-widest hover:bg-emerald-100 transition-all flex items-center gap-2"
                                                            title="Download Document"
                                                        >
                                                            <FiDownload size={12} /> Download
                                                        </button>
                                                    </>
                                                )}
                                                <button
                                                    disabled={historyLoading}
                                                    onClick={() => handleDeleteHistoryItem(item._id)}
                                                    className="p-2 text-rose-400 hover:text-rose-600 hover:bg-rose-50 rounded-xl transition-all"
                                                    title="Delete History Entry"
                                                >
                                                    <FiTrash2 size={14} />
                                                </button>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            ) : (
                                <div className="text-center py-20 bg-gray-50 rounded-3xl border border-dashed border-gray-200">
                                    <div className="w-16 h-16 bg-white text-gray-300 rounded-full flex items-center justify-center mx-auto mb-4 shadow-sm">
                                        <FiClock size={32} />
                                    </div>
                                    <h3 className="text-lg font-black text-gray-800 uppercase tracking-tight">No history found</h3>
                                    <p className="text-xs text-gray-400 font-bold uppercase tracking-widest mt-1">No documents have been sent to this candidate yet.</p>
                                </div>
                            )}
                        </div>

                        <div className="p-6 bg-gray-50 border-t border-gray-100 flex justify-end">
                            <button
                                onClick={() => setIsHistoryModalOpen(false)}
                                className="px-8 py-2 bg-white text-gray-700 border border-gray-200 rounded-xl font-black text-[10px] uppercase tracking-widest hover:bg-gray-50 transition-all shadow-sm"
                            >
                                Close History
                            </button>
                        </div>
                    </div>
                </div>
            )}
            </main>
        </div>
    );
};

export default Score;